import React, { Suspense, lazy } from "react";
import "./Footer.css";
 
const SwmcFooter = lazy(() => import("footer-component").then(module => ({ default: module.SwmcFooter })));

const CustomFooter = () => {
  return (
    <div>
      <Suspense fallback={<div>Loading footer...</div>}>
       
        <SwmcFooter type="swmc" showTacanewLogo={true} nydisclaimer={true} />
      </Suspense>
    </div>
  );
};

export default CustomFooter;
